import { createPortal } from 'react-dom';
import {
  BookOpenIcon,
  BookmarkIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import {
  BookOpenIcon as BookOpenSolidIcon,
  BookmarkIcon as BookmarkSolidIcon,
  UserGroupIcon as UserGroupSolidIcon,
} from '@heroicons/react/24/solid';

/**
 * Mobile bottom navigation bar for the preview page.
 * Rendered via Portal to document.body so position:fixed works
 * reliably on iOS Safari regardless of ancestor transforms/overflow.
 */
export default function MobileBottomNav({ activeTab, onTabChange }) {
  const tabs = [
    { 
      id: 'story', 
      label: 'Story', 
      icon: BookOpenIcon,
      activeIcon: BookOpenSolidIcon,
    },
    { 
      id: 'chapters', 
      label: 'Chapters', 
      icon: BookmarkIcon,
      activeIcon: BookmarkSolidIcon,
    },
    { 
      id: 'cast', 
      label: 'Cast', 
      icon: UserGroupIcon,
      activeIcon: UserGroupSolidIcon,
    },
  ];

  return createPortal(
    <nav className="lg:hidden fixed bottom-0 inset-x-0 bg-white border-t border-parchment z-50 safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const Icon = isActive ? tab.activeIcon : tab.icon;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex flex-col items-center justify-center flex-1 h-full
                transition-colors duration-200
                ${isActive 
                  ? 'text-rust' 
                  : 'text-sepia hover:text-ink'
                }
              `}
            >
              <Icon className="w-6 h-6 mb-1" />
              <span className={`text-xs font-medium ${isActive ? 'font-semibold' : ''}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>,
    document.body
  );
}


